import {InputNumber, Modal, Row, Col} from 'antd';
import {useState} from "react";
import {getUnitPrecision} from "../../util/unitutils";
import {UnitType, CategoryType} from "../../api/Constants";
import {gramsToLbs, lbsToGrams} from "../../util/unitutils";

export const AddCartWidget = ({onAdjust, item, props, children}) => {
    const [isOpen, setOpen] = useState(false);
    const [quantity, setQuantity] = useState(0);
    const [lbsQuantity, setLbsQuantity] = useState(0)

    const isGrams = item.category === CategoryType.Wholesale;

    const onOpen = () => {
        setOpen(true);
    }

    const onOk = () => {
        setOpen(false)
        if (onAdjust) {
            onAdjust(quantity);
        }
    }

    const onCancel = () => {
        setOpen(false);
    }

    const onInputChange = (val) => {
        if (val) {
            setQuantity(val);
            if (isGrams) {
                setLbsQuantity(gramsToLbs(val))
            }
        } else {
            setQuantity(0);
            if (isGrams) {
                setLbsQuantity(0);
            }
        }
    }

    const inputPrecision = 0;
    const lbsPrecision = getUnitPrecision(UnitType.Lbs);

    const lbsInputChange = (val) => {
        const gramsVal = lbsToGrams(val);
        console.log(`setting grams to ${gramsVal}`);
        const clipGrams = gramsVal > item.quantity ? item.quantity: gramsVal;
        setQuantity(clipGrams);
    }

    return (
        <div>
            <div style={{cursor: 'pointer'}} onClick={onOpen}>{children}</div>
            <Modal title={"Select Items from Inventory for Use"} width={400} open={isOpen} onOk={onOk} onCancel={onCancel}>
                <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col><InputNumber min={0} max={item.quantity} style={{width: 300}} onChange={onInputChange} precision={inputPrecision} value={quantity} /></Col>
                    <Col style={{margin: "5px"}}>{isGrams ? `grams`: `units`}</Col>
                </Row>
                {isGrams &&
                <Row style={{paddingTop: '5px', paddingBottom: '5px'}}>
                    <Col><InputNumber min={0} max={gramsToLbs(item.quantity)+1} style={{width: 300}} onChange={lbsInputChange} precision={lbsPrecision} value={lbsQuantity} /></Col>
                    <Col style={{margin: "5px"}}>{UnitType.Label[UnitType.Lbs]}</Col>
                </Row>
                }
            </Modal>
        </div>
    )
}